/* global customElements, HTMLElement */

class AccordionElement extends HTMLElement {
  /**
   * Open the accordion item when the corresponding hash is in the URL
   * and focus the item.
   *
   * @returns {void}
   */
  connectedCallback () {
    // auto-pause all embeds when the accordion item is closed

    this.addEventListener('toggle', (e) => {
      if (!e.target.matches('.js-accordion__item')) {
        return
      }

      if (e.newState !== 'closed') {
        return
      }

      this.pauseAllEmbeds(e.target)
    }, { capture: true })

    // check if the accordion item is already open
    // open accordion item when the corresponding hash is in the url
    const hash = window.location.hash.replace(/^#/, '')

    if (!hash) {
      return
    }

    const $details = document.getElementById(hash)

    if ($details) {
      $details.open = true
      $details.focus()
    }
  }

  pauseAllEmbeds ($details) {
    const $$embeds = $details.querySelectorAll('x-embed')

    $$embeds.forEach($embed => $embed.pause())
  }
}

customElements.define('x-accordion', AccordionElement)
